import React from "react";
import { AddToCalendarButton } from "add-to-calendar-button-react";
import styled from "styled-components";

const AddToCalendarCustomButton = ({
  name = "Title",
  options = ["Apple", "Google", "Yahoo", "iCal"],
  location = "World Wide Web",
  startDate = "2025-06-05",
  endDate = "2025-06-05",
  startTime = "10:15",
  endTime = "23:30",
  timeZone = "America/New_York",
  description,
  buttonStyle = "default",
  listStyle = "overlay",
  lightMode = "system",
  language = "en",
  size,
  hideIconButton,
  hideTextLabelButton,
  hideBackground,
  hideCheckmark,
  ...otherProps
}) => {
  return (
    <StyledCalendarButton>
      <AddToCalendarButton
        name={name}
        options={options}
        location={location}
        startDate={startDate}
        endDate={endDate}
        startTime={startTime}
        endTime={endTime}
        timeZone={timeZone}
        description={description}
        buttonStyle={buttonStyle}
        listStyle={listStyle}
        lightMode={lightMode}
        language={language}
        size={size}
        hideIconButton={hideIconButton}
        hideTextLabelButton={hideTextLabelButton}
        hideBackground={hideBackground}
        hideCheckmark={hideCheckmark}
        {...otherProps}
      >
        Add to Calendar
      </AddToCalendarButton>
    </StyledCalendarButton>
  );
};
const StyledCalendarButton = styled.button`
  .atcb-button {
    line-height: 1.2;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    position: relative;
    border: none;
    transition: all 0.5s;
    border-radius: 5px;
    margin: 1.2rem auto;
    padding: 0.8rem 2rem;
    font-size: 1rem;
    font-weight: 400;
    color: var(--white);
    background-color: var(--red) !important;
    text-decoration: none;
    max-width: 100%;
    width: auto;

    &:hover {
      color: var(--black);
      background: white;
    }
  }
  @media (max-width: 426px) {
    width: 100%;
    padding: 0.5rem 1rem;
  }
`;

export default AddToCalendarCustomButton;
